import { render, staticRenderFns } from "./JVDocument.vue?vue&type=template&id=495b8166&scoped=true&"
import script from "./JVDocument.vue?vue&type=script&lang=js&"
export * from "./JVDocument.vue?vue&type=script&lang=js&"
import style0 from "./JVDocument.vue?vue&type=style&index=0&id=495b8166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b8166",
  null
  
)

export default component.exports